import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from '@mui/material';
const Content = ({ attributes }) => {
    return (_jsx("div", { "data-testid": `node/text/${attributes.id}/text`, children: _jsx("code", { children: attributes.text.text }) }));
};
export const NodeText = ({ node, attributes }) => {
    return (_jsxs(_Fragment, { children: [_jsx(Typography, { "data-testid": `node/text/${attributes.id}/label`, children: node.meta.label?.text }), _jsx(Content, { node: node, attributes: attributes })] }));
};
